import { AiLayout } from '@/features/ai/AiLayout';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/ai')({
  staticData: { nav: 'ai' },
  component: AiLayout,
});
